<template>
    <span>
        <b-overlay
              :show="isBusy"
              rounded
              opacity="0.6"
              spinner-small
              spinner-variant="primary"
              >
              <b-button v-bind="$attrs" :id="'popover-button-sync-approval-' + approvalType.toLowerCase()" class="btn-action d-flex" size="sm" @click="openPopover"><b-icon :icon="icon" class="mr-1"></b-icon><span class="btn-text"> {{ approvalType }}</span></b-button>
        </b-overlay>
        <b-popover :show.sync="popoverShow" :target="'popover-button-sync-approval-' + approvalType.toLowerCase()" title="Remarks" placement="bottomleft">
            <b-form-textarea rows="3" class="textarea-popover" v-model="inputRemarks"></b-form-textarea>
            <div class="popover-action float-right mt-2 mb-1">
                <b-button @click="closePopover" size="sm" class="btn-default-white">Cancel</b-button>
                <b-button @click="processApproval" size="sm" class="btn-default ml-2">{{ approvalType }}</b-button>
            </div>
        </b-popover>
    </span>
</template>
<style scoped lang="scss">
    .btn-text {
        margin-top: -1.5px;
    }
</style>
<script>
    import PopupApprovalHistory from './PopupApprovalHistory.vue';
    
    export default {
      name: 'PopupWrap',
      components: {PopupApprovalHistory},
      props: {
        approvalMethod: {},
        approvalType: {
            default: '',
            type: String,
        },
        icon: {
            default: '',
            type: String,
        },
        isBusy: {
            default: false,
            type: Boolean,
        },
        remarks: {
            default: '',
            type: String,
        },
      },
      data() {
        return {
            inputRemarks: '',
            popoverShow: false,
        }
      },
      mounted() {
      },
      watch : {
        remarks : function(val) {
            this.inputRemarks = val;
        },
      },
      methods: {
        openPopover() {
            this.popoverShow = true;
        },
        closePopover() {
            this.popoverShow = false;
        },
        processApproval(modalEvent) {
            this.$emit('update:remarks', this.inputRemarks);
            this.$emit("approvalMethod", modalEvent, this.$emit);
            this.popoverShow = false;
        },
      },
    };
    </script>
